const questionnaireActions = {
  REQUEST_QUESTIONNAIRES: "REQUEST_QUESTIONNAIRES",
  RECIEVE_QUESTIONNAIRES: "RECIEVE_QUESTIONNAIRES",
  SERVER_ERROR_OCURED: 'SERVER_ERROR_OCURED',
  CLEAR_ERRORS: 'CLEAR_ERRORS',
  REQUEST_TEMPLATES: "REQUEST_TEMPLATES",
  RECIEVE_TEMPLATES: "RECIEVE_TEMPLATES",
  TEMPLATE_SERVER_ERROR_OCCURED: "TEMPLATE_SERVER_ERROR_OCCURED",
  TEMPLATE_CLEAR_ERRORS: "TEMPLATE_CLEAR_ERRORS"
}

export default questionnaireActions;


// WEBPACK FOOTER //
// src/routes/Questionnaire/actions/actionTypes.js